import { FC } from 'react';
import { CreateUserCard } from 'features/user';

export const CreateUserPage: FC = () => {
  return <CreateUserCard />;
};
